import { modifier } from "ember-modifier"

// TODO type handler - this is cheap shortcut, Marika
export default modifier((element, [handler]: any) => {
  if (window) window.addEventListener("resize", handler)
  if (window) window.addEventListener("orientationchange", handler)

  return () => {
    if (window) window.removeEventListener("resize", handler)
    if (window) window.removeEventListener("orientationchange", handler)
  }
})
